import React from "react";
import { Container, ImgBox, Text1, Text2, TextBox } from "./style";
import { useTranslation } from "react-i18next";
const Com4 = () => {
  const { t } = useTranslation("home");
  return (
    <Container>
      <TextBox>
        <Text1>
          <img loading="lazy" src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/be0427b7Home_8.svg" alt="" />
          <span>{t("4-1")}</span>
        </Text1>
        <Text2>
          <span>{t("4-2")}</span>
          <span>{t("4-3")}</span>
        </Text2>
      </TextBox>
    </Container>
  );
};

export default Com4;
